import { getDashConfig, setJwt } from "./httpService";
import http from "./httpService";
import { dashApiUrl } from "../configs/config.json";
import { getEpochTime } from "./dateService";
import { saveDashToken, loadB2CEmail, saveB2CEmail } from "./authService";

const apiEndpoint = dashApiUrl;

const apiErrorLog = (endpoint, error, requestData) => {
	const fullMessage = `API Error, Endpoint: '${endpoint}'${
		error.message ? ` Error: ${error.message}` : ""
	}`;

	console.error(fullMessage);
	console.error(error);
	console.error(requestData);
};

function logActivity(type, src, payload) {
	return new Promise((resolve, reject) => {
		const requestData = {
			action: "logActivity",
			data: {
				type,
				src,
				payload,
			},
		};

		http
			.post(apiEndpoint, requestData, getDashConfig())
			.then((response) => {
				const data = response.data;
				resolve(data);
			})
			.catch((error) => {
				apiErrorLog("deleteCost", error, requestData);
				reject(error);
			});
	});
}

function deleteCost(id) {
	return new Promise((resolve, reject) => {
		const requestData = {
			action: "deleteCost",
			data: {
				id: id,
			},
		};

		http
			.post(apiEndpoint, requestData, getDashConfig())
			.then((response) => {
				const data = response.data;
				resolve(data);
			})
			.catch((error) => {
				apiErrorLog("deleteCost", error, requestData);
				reject(error);
			});
	});
}

function deleteResponse(id) {
	return new Promise((resolve, reject) => {
		const requestData = {
			action: "deleteResponse",
			data: {
				id: id,
			},
		};

		http
			.post(apiEndpoint, requestData, getDashConfig())
			.then((response) => {
				const data = response.data;
				resolve(data);
			})
			.catch((error) => {
				apiErrorLog("deleteResponse", error, requestData);
				reject(error);
			});
	});
}

function getCompletedResponses(code, start, end, flatten) {
	return new Promise((resolve, reject) => {
		const requestData = {
			action: "getCompletedResponses",
			data: {
				code: code,
				start: start,
				end: end,
				flatten: flatten,
			},
		};

		http
			.post(apiEndpoint, requestData, getDashConfig())
			.then((response) => {
				const data = response.data;
				resolve(data);
			})
			.catch((error) => {
				apiErrorLog("getCompletedResponses", error, requestData);
				reject(error);
			});
	});
}

function getCompletedResponseSet(summary, id) {
	return new Promise((resolve, reject) => {
		const requestData = {
			action: "getCompletedResponseSet",
			data: {
				summary: summary,
				id: id,
			},
		};

		http
			.post(apiEndpoint, requestData, getDashConfig())
			.then((response) => {
				const data = response.data;
				resolve(data);
			})
			.catch((error) => {
				apiErrorLog("getCompletedResponseSet", error, requestData);
				reject(error);
			});
	});
}

function getNurseToDoResponseSet(summary, id) {
	return new Promise((resolve, reject) => {
		const requestData = {
			action: "getNurseTodoResponseSet",
			data: {
				summary: summary,
				id: id,
			},
		};

		http
			.post(apiEndpoint, requestData, getDashConfig())
			.then((response) => {
				const data = response.data;
				resolve(data);
			})
			.catch((error) => {
				apiErrorLog("getNurseTodoResponseSet", error, requestData);
				reject(error);
			});
	});
}

function getConsent() {
	return new Promise((resolve, reject) => {
		const requestData = { action: "getConsent", data: {} };
		http
			.post(apiEndpoint, requestData, getDashConfig())
			.then((response) => {
				const data = response.data;
				resolve(data);
			})
			.catch((error) => {
				apiErrorLog("getConsent", error, requestData);
				reject(error);
			});
	});
}

function getCosts(start, end) {
	return new Promise((resolve, reject) => {
		const requestData = {
			action: "getCosts",
			data: {
				start: start,
				end: end,
			},
		};

		http
			.post(apiEndpoint, requestData, getDashConfig())
			.then((response) => {
				const data = response.data;

				resolve(data);
			})
			.catch((error) => {
				apiErrorLog("getCosts", error, requestData);
				reject(error);
			});
	});
}

function getCostMonthSelector() {
	return new Promise((resolve, reject) => {
		const requestData = {
			action: "getCostMonthSelector",
			data: {},
		};

		http
			.post(apiEndpoint, requestData, getDashConfig())
			.then((response) => {
				const data = response.data;

				resolve(data);
			})
			.catch((error) => {
				apiErrorLog("getCostMonthSelector", error, requestData);
				reject(error);
			});
	});
}

function getCostTypes() {
	return new Promise((resolve, reject) => {
		const requestData = { action: "getCostTypes", data: {} };
		http
			.post(apiEndpoint, requestData, getDashConfig())
			.then((response) => {
				const data = response.data;

				resolve(data);
			})
			.catch((error) => {
				apiErrorLog("getCostTypes", error, requestData);
				reject(error);
			});
	});
}

function getDueResponseCount() {
	return new Promise((resolve, reject) => {
		const requestData = { action: "getDueResponseCount", data: {} };
		http
			.post(apiEndpoint, requestData, getDashConfig())
			.then((response) => {
				const data = response.data;

				resolve(data);
			})
			.catch((error) => {
				apiErrorLog("getDueResponseCount", error, requestData);
				reject(error);
			});
	});
}

function getDueResponseSet(summary, id) {
	return getToDoResponseSet(summary, id);
}

function getFootprintData(code, date) {
	return new Promise((resolve, reject) => {
		const requestData = {
			action: "getFootprintData",
			data: {
				code: code,
			},
		};

		if (date) {
			requestData.data.date = date;
		}

		http
			.post(apiEndpoint, requestData, getDashConfig())
			.then((response) => {
				const data = response.data;

				resolve(data);
			})
			.catch((error) => {
				apiErrorLog("getFootprintData", error, requestData);
				reject(error);
			});
	});
}

function getHelp(objectify, code, registration) {
	return new Promise((resolve, reject) => {
		const requestData = {
			action: "getHelp",
			data: {
				objectify: objectify,
				code: code,
			},
		};

		http
			.post(
				`${apiEndpoint}${registration ? "/registration" : ""}`,
				requestData,
				getDashConfig()
			)
			.then((response) => {
				const data = response.data;
				resolve(data);
			})
			.catch((error) => {
				apiErrorLog("getHelp", error, requestData);
				reject(error);
			});
	});
}

function register(data) {
	return new Promise((resolve, reject) => {
		const requestData = {
			action: "register",
			data,
		};

		http
			.post(`${apiEndpoint}/registration`, requestData)
			.then((response) => {
				const data = response.data;
				resolve(data);
			})
			.catch((error) => {
				apiErrorLog("register", error, requestData);
				reject(error);
			});
	});
}

function getHelpItemsByType(type) {
	return new Promise((resolve, reject) => {
		const requestData = {
			action: "getHelp",
			data: {
				type: type,
			},
		};

		http
			.post(apiEndpoint, requestData, getDashConfig())
			.then((response) => {
				const data = response.data;
				resolve(data);
			})
			.catch((error) => {
				apiErrorLog("getHelpItemsByType", error, requestData);
				reject(error);
			});
	});
}

function getUsefulLinks() {
	return new Promise((resolve, reject) => {
		const requestData = {
			action: "getUsefulLinks",
			data: {},
		};

		http
			.post(apiEndpoint, requestData, getDashConfig())
			.then((response) => {
				const data = response.data;
				resolve(data);
			})
			.catch((error) => {
				apiErrorLog("getUsefulLinks", error, requestData);
				reject(error);
			});
	});
}

function getMissedResponseSet(summary, id) {
	return new Promise((resolve, reject) => {
		const requestData = {
			action: "getMissedResponseSet",
			data: {
				summary: summary,
				id: id,
			},
		};

		http
			.post(apiEndpoint, requestData, getDashConfig())
			.then((response) => {
				const data = response.data;

				resolve(data);
			})
			.catch((error) => {
				apiErrorLog("getMissedResponseSet", error, requestData);
				reject(error);
			});
	});
}

function getPID() {
	return new Promise((resolve, reject) => {
		const requestData = { action: "getPID", data: {} };

		http
			.post(apiEndpoint, requestData, getDashConfig())
			.then((response) => {
				const data = response.data;

				resolve(data);
			})
			.catch((error) => {
				apiErrorLog("getPID", error, requestData);
				reject(error);
			});
	});
}

function getQuestionnaire(code, version) {
	return new Promise((resolve, reject) => {
		const requestData = {
			action: "getQuestionnaire",
			data: {
				code: code,
				version: version,
			},
		};

		http
			.post(apiEndpoint, requestData, getDashConfig())
			.then((response) => {
				const data = response.data;
				resolve(data);
			})
			.catch((error) => {
				apiErrorLog("getQuestionnaire", error, requestData);
				reject(error);
			});
	});
}

function getResponse(id, questionnaireId) {
	return new Promise((resolve, reject) => {
		const requestData = {
			action: "getResponse",
			data: {
				id: id,
				questionnaireId: questionnaireId,
			},
		};

		http
			.post(apiEndpoint, requestData, getDashConfig())
			.then((response) => {
				const data = response.data;
				resolve(data);
			})
			.catch((error) => {
				apiErrorLog("getResponse", error, requestData);
				reject(error);
			});
	});
}

function getResponseHistory(code, start, end) {
	return new Promise((resolve, reject) => {
		const requestData = {
			action: "getResponseHistory",
			data: {
				code: code,
				start: start,
				end: end,
			},
		};

		http
			.post(apiEndpoint, requestData, getDashConfig())
			.then((response) => {
				const data = response.data;
				resolve(data);
			})
			.catch((error) => {
				apiErrorLog("getResponseHistory", error, requestData);
				reject(error);
			});
	});
}

function getResponseSet(summary) {
	return new Promise((resolve, reject) => {
		const requestData = {
			action: "getResponseSet",
			data: {
				summary: summary,
			},
		};

		http
			.post(apiEndpoint, requestData, getDashConfig())
			.then((response) => {
				const data = response.data;
				resolve(data);
			})
			.catch((error) => {
				apiErrorLog("getResponseSet", error, requestData);
				reject(error);
			});
	});
}

function getSettings() {
	return new Promise((resolve, reject) => {
		const requestData = { action: "getSettings", data: {} };
		http
			.post(apiEndpoint, requestData, getDashConfig())
			.then((response) => {
				const data = response.data;
				resolve(data);
			})
			.catch((error) => {
				apiErrorLog("getSettings", error, requestData);
				reject(error);
			});
	});
}

function getSettingsCompletionStatus() {
	return new Promise((resolve, reject) => {
		const requestData = { action: "getSettingsCompletionStatus", data: {} };
		http
			.post(apiEndpoint, requestData, getDashConfig())
			.then((response) => {
				const data = response.data;
				resolve(data);
			})
			.catch((error) => {
				apiErrorLog("getSettingsCompletionStatus", error, requestData);
				reject(error);
			});
	});
}

function getSummaryData(code) {
	return new Promise((resolve, reject) => {
		const requestData = {
			action: "getSummaryData",
			data: {
				code: code,
			},
		};

		http
			.post(apiEndpoint, requestData, getDashConfig())
			.then((response) => {
				resolve(response.data);
			})
			.catch((error) => {
				apiErrorLog("getSummaryData", error, requestData);
				reject(error);
			});
	});
}

function getSummaryDefinition(code) {
	return new Promise((resolve, reject) => {
		const requestData = {
			action: "getSummaryDefinition",
		};

		if (code) {
			requestData.code = code;
		}

		http
			.post(apiEndpoint, requestData, getDashConfig())
			.then((response) => {
				const data = response.data;

				resolve(data);
			})
			.catch((error) => {
				apiErrorLog("getSummaryDefinition", error, requestData);
				reject(error);
			});
	});
}

function getSysInfo() {
	return new Promise((resolve, reject) => {
		const requestData = {
			action: "getSysInfo",
			data: {},
		};

		http
			.post(apiEndpoint, requestData, getDashConfig())
			.then((response) => {
				const data = response.data;
				resolve(data);
			})
			.catch((error) => {
				apiErrorLog("getSysInfo", error, requestData);
				reject(error);
			});
	});
}

function getVersionInfo() {
	return new Promise((resolve, reject) => {
		const requestData = {
			action: "getVersionInfo",
			data: {},
		};

		http
			.post(apiEndpoint, requestData, getDashConfig())
			.then((response) => {
				const data = response.data;
				resolve(data);
			})
			.catch((error) => {
				apiErrorLog("getVersionInfo", error, requestData);
				reject(error);
			});
	});
}

function getRegistrationSysInfo(diseaseGroup) {
	return new Promise((resolve, reject) => {
		const requestData = {
			action: "getSysInfo",
			data: { diseaseGroup },
		};

		http
			.post(`${apiEndpoint}/registration`, requestData)
			.then((response) => {
				const data = response.data;
				resolve(data);
			})
			.catch((error) => {
				apiErrorLog("getRegistrationSysInfo", error, requestData);
				reject(error);
			});
	});
}

function getTableData(code, date) {
	return new Promise((resolve, reject) => {
		const requestData = {
			action: "getTableData",
			data: {
				code: code,
			},
		};

		if (date) {
			requestData.data.date = date;
		}

		http
			.post(apiEndpoint, requestData, getDashConfig())
			.then((response) => {
				const data = response.data;
				resolve(data);
			})
			.catch((error) => {
				apiErrorLog("getTableData", error, requestData);
				reject(error);
			});
	});
}

function getTimechartData(code, selector) {
	return new Promise((resolve, reject) => {
		const requestData = {
			action: "getTimechartData",
			data: {
				code: code,
				selector,
			},
		};

		http
			.post(apiEndpoint, requestData, getDashConfig())
			.then((response) => {
				const data = response.data;
				resolve(data);
			})
			.catch((error) => {
				apiErrorLog("getTimechartData", error, requestData);
				reject(error);
			});
	});
}

//this needs to be renamed
function getToDoResponseSet(summary, id) {
	return new Promise((resolve, reject) => {
		const requestData = {
			action: "getDueResponseSet",
			data: {
				summary: summary,
				id: id,
			},
		};

		http
			.post(apiEndpoint, requestData, getDashConfig())
			.then((response) => {
				const data = response.data;
				resolve(data);
			})
			.catch((error) => {
				apiErrorLog("getDueResponseSet", error, requestData);
				reject(error);
			});
	});
}

function getUpcomingResponseSet(summary, id) {
	return new Promise((resolve, reject) => {
		const requestData = {
			action: "getUpcomingResponseSet",
			data: {
				summary: summary,
				id: id,
			},
		};

		http
			.post(apiEndpoint, requestData, getDashConfig())
			.then((response) => {
				const data = response.data;

				resolve(data);
			})
			.catch((error) => {
				apiErrorLog("getUpcomingResponseSet", error, requestData);
				reject(error);
			});
	});
}

function login(b2cJwt, data) {
	return new Promise((resolve, reject) => {
		const bearer = `Bearer ${b2cJwt}`;

		const httpConfig = {
			headers: {
				authorization: bearer,
			},
		};

		const requestData = { action: "login", data: data || {} };

		http
			.post(apiEndpoint, requestData, httpConfig)
			.then((response) => {
				const data = response.data;
				const token = (response.headers.authorization || "").replace(
					"Bearer ",
					""
				);

				if (data.success === true) {
					if (!loadB2CEmail() && data.data.email) {
						saveB2CEmail(data.data.email);
					}
					saveDashToken(token);
					setJwt(token);

					resolve(data);
				} else if (data.data.isUnsupportedApp) {
					reject({
						errorCode: "unsupported_app",
						message:
							data.data.message ||
							"This version of the Companion App is no longer supported.",
					});
				} else {
					reject(data.data);
				}
			})
			.catch((error) => {
				apiErrorLog("login", error, requestData);
				reject(error);
			});
	});
}

function logout() {
	return new Promise((resolve, reject) => {
		const requestData = { action: "logout", data: {} };
		http
			.post(apiEndpoint, requestData, getDashConfig())
			.then((response) => {
				const data = response.data;
				resolve(data);
			})
			.catch((error) => {
				apiErrorLog("logout", error, requestData);
				reject(error);
			});
	});
}

function recordHelpAccessed(type, code) {
	return new Promise((resolve, reject) => {
		const requestData = {
			action: "recordHelpAccessed",
			data: {
				type: type,
				code: code,
			},
		};

		http
			.post(apiEndpoint, requestData, getDashConfig())
			.then((response) => {
				const data = response.data;
				resolve(data);
			})
			.catch((error) => {
				apiErrorLog("recordHelpAccessed", error, requestData);
				reject(error);
			});
	});
}

function saveCost(idOrDetails, incurred, description, payer, type, amount) {
	if (typeof idOrDetails === "object") {
		return saveCostFromObject(idOrDetails);
	}

	return saveCostFromDetails(
		idOrDetails,
		incurred,
		description,
		payer,
		type,
		amount
	);
}

function saveCostFromDetails(id, incurred, description, payer, type, amount) {
	var costDetails = {
		id: id,
		incurred: incurred,
		description: description,
		payer: payer,
		type: type,
		amount: amount,
	};

	return saveCostFromObject(costDetails);
}

function saveCostFromObject(costDetails) {
	return new Promise((resolve, reject) => {
		const requestData = {
			action: "saveCost",
			data: costDetails,
		};

		http
			.post(apiEndpoint, requestData, getDashConfig())
			.then((response) => {
				const data = response.data;
				resolve(data);
			})
			.catch((error) => {
				apiErrorLog("", error, requestData);
				reject((error) => {
					apiErrorLog("saveCost", error, requestData);
					reject(error);
				});
			});
	});
}

function saveResponse(
	id,
	questionnaireId,
	def,
	complete,
	responseHistory,
	action = "saveResponse"
) {
	return new Promise((resolve, reject) => {
		const requestData = {
			action,
			data: {
				id: id,
				questionnaireId: questionnaireId,
				def: def,
				complete: complete,
				responseHistory: {
					id: questionnaireId,
					history: responseHistory,
				},
			},
		};

		http
			.post(apiEndpoint, requestData, getDashConfig())
			.then((response) => {
				const data = response.data;
				resolve(data);
			})
			.catch((error) => {
				apiErrorLog("saveResponse", error, requestData);
				reject(error);
			});
	});
}

function setConsent(consent) {
	return new Promise((resolve, reject) => {
		const requestData = {
			action: "setSettings",
			data: {
				consent: consent,
			},
		};

		http
			.post(apiEndpoint, requestData, getDashConfig())
			.then((response) => {
				const data = response.data;
				resolve(data);
			})
			.catch((error) => {
				apiErrorLog("setConsent", error, requestData);
				reject(error);
			});
	});
}

function setConsentConfirmed() {
	return new Promise((resolve, reject) => {
		const requestData = { action: "setConsentConfirmed", data: {} };

		http
			.post(apiEndpoint, requestData, getDashConfig())
			.then((response) => {
				const data = response.data;
				resolve(data);
			})
			.catch((error) => {
				apiErrorLog("setConsentConfirmed", error, requestData);
				reject(error);
			});
	});
}

//deprecated
// function setInitialQuestionnaires(offset) {
// 	return new Promise((resolve, reject) => {
// 		const requestData = {
// 			action: "setInitialQuestionnaires",
// 			data: {
// 				offset: offset,
// 			},
// 		};

// 		http
// 			.post(apiEndpoint, requestData, getDashConfig())
// 			.then((response) => {
// 				const data = response.data;
// 				resolve(data);
// 			})
// 			.catch(reject);
// 	});
// }

function setHelpAccessed(id) {
	return new Promise((resolve, reject) => {
		const requestData = {
			action: "setHelpAccessed",
			data: {
				id: id,
			},
		};

		http
			.post(apiEndpoint, requestData, getDashConfig())
			.then((response) => {
				const data = response.data;
				resolve(data);
			})
			.catch((error) => {
				apiErrorLog("setHelpAccessed", error, requestData);
				reject(error);
			});
	});
}

function setPID(
	emailOrDetails,
	displayName,
	firstName,
	surname,
	postalCode,
	mobilePhone,
	nhsNo,
	dob
) {
	if (typeof emailOrDetails === "object") {
		return setPIDFromObject(emailOrDetails);
	}

	return setPIDFromDetails(
		emailOrDetails,
		displayName,
		firstName,
		surname,
		postalCode,
		mobilePhone,
		nhsNo,
		dob
	);
}

function setPIDFromDetails(
	email,
	displayName,
	firstName,
	surname,
	postalCode,
	mobilePhone,
	nhsNo,
	dob
) {
	const userDetails = {
		email: email,
		displayName: displayName,
		firstName: firstName,
		surname: surname,
		postalCode: postalCode,
		mobilePhone: mobilePhone,
		nhsNo: nhsNo,
		dob: dob,
	};

	return setPIDFromObject(userDetails);
}

function setPIDFromObject(userDetails) {
	if (userDetails.dob) {
		if (typeof userDetails.dob === "object") {
			//is a Date, needs setting to an epoch value
			var value = getEpochTime(userDetails.dob);
			userDetails.dob = value;
		}
	}

	return new Promise((resolve, reject) => {
		const requestData = {
			action: "setPID",
			data: userDetails,
		};

		http
			.post(apiEndpoint, requestData, getDashConfig())
			.then((response) => {
				const data = response.data;

				resolve(data);
			})
			.catch((error) => {
				apiErrorLog("setPIDFromObject", error, requestData);
				reject(error);
			});
	});
}

function setResponse(id, def, submitted) {
	return new Promise((resolve, reject) => {
		const requestData = {
			action: "setResponse",
			data: {
				id: id,
				def: def,
				submitted: submitted,
			},
		};

		http
			.post(apiEndpoint, requestData, getDashConfig())
			.then((response) => {
				const data = response.data;

				resolve(data);
			})
			.catch((error) => {
				apiErrorLog("setResponse", error, requestData);
				reject(error);
			});
	});
}

function setSettings(settings) {
	return new Promise((resolve, reject) => {
		const requestData = {
			action: "setSettings",
			data: {
				settings: settings,
			},
		};

		http
			.post(apiEndpoint, requestData, getDashConfig())
			.then((response) => {
				const data = response.data;
				resolve(data);
			})
			.catch((error) => {
				apiErrorLog("setSettings", error, requestData);
				reject(error);
			});
	});
}

function validateInitialRegistrationData(email, nhsno, source = "register") {
	return new Promise((resolve, reject) => {
		const requestData = {
			action: "validateInitialRegistrationData",
			data: {
				email,
				nhsno,
				source,
			},
		};

		http
			.post(`${apiEndpoint}/registration`, requestData)
			.then((response) => {
				const data = response.data;
				resolve(data);
			})
			.catch((error) => {
				apiErrorLog("validateInitialRegistrationData", error, requestData);
				reject(error);
			});
	});
}

function validatePID(email, nhsno) {
	return new Promise((resolve, reject) => {
		const requestData = {
			action: "validatePID",
			data: {
				email,
				nhsno,
			},
		};

		http
			.post(apiEndpoint, requestData, getDashConfig())
			.then((response) => {
				const data = response.data;
				resolve(data);
			})
			.catch((error) => {
				apiErrorLog("validatePID", error, requestData);
				reject(error);
			});
	});
}

function validateVerificationCode(email, code, source = "register") {
	return new Promise((resolve, reject) => {
		const requestData = {
			action: "validateVerificationCode",
			data: {
				email: email.replace(/ /g, "").toLowerCase(),
				code,
				source,
			},
		};

		http
			.post(`${apiEndpoint}/registration`, requestData)
			.then((response) => {
				const data = response.data;
				resolve(data);
			})
			.catch((error) => {
				apiErrorLog("validateVerificationCode", error, requestData);
				reject(error);
			});
	});
}

function getList(code, zeroOption, zeroOptionDisplay, filter) {
	return new Promise((resolve, reject) => {
		const requestData = {
			action: "getList",
			data: {
				code,
				zeroOption,
				zeroOptionDisplay,
				filter,
			},
		};

		http
			.post(`${apiEndpoint}/registration`, requestData)
			.then((response) => {
				const data = response.data;
				resolve(data);
			})
			.catch((error) => {
				apiErrorLog("getList", error, requestData);
				reject(error);
			});
	});
}

function getHospitals() {
	return new Promise((resolve, reject) => {
		const requestData = {
			action: "getHospitals",
			data: {},
		};

		http
			.post(apiEndpoint, requestData, getDashConfig())
			.then((response) => {
				const data = response.data;
				resolve(data);
			})
			.catch((error) => {
				apiErrorLog("getHospitals", error, requestData);
				reject(error);
			});
	});
}

function getDrugList(data) {
	return new Promise((resolve, reject) => {
		const requestData = {
			action: "getDrugList",
			data: data || {},
		};

		http
			.post(apiEndpoint, requestData, getDashConfig())
			.then((response) => {
				const data = response.data;
				resolve(data);
			})
			.catch((error) => {
				apiErrorLog("getDrugList", error, requestData);
				reject(error);
			});
	});
}

export {
	deleteCost,
	deleteResponse,
	getCompletedResponses,
	getCompletedResponseSet,
	getConsent,
	getCosts,
	getCostMonthSelector,
	getCostTypes,
	getDrugList,
	getDueResponseCount,
	getDueResponseSet,
	getFootprintData,
	getHelp,
	getHelpItemsByType,
	getHospitals,
	getList,
	getMissedResponseSet,
	getPID,
	getQuestionnaire,
	getRegistrationSysInfo,
	getResponse,
	getResponseHistory,
	getResponseSet,
	getSettings,
	getSettingsCompletionStatus,
	getSummaryData,
	getSummaryDefinition,
	getSysInfo,
	getTableData,
	getTimechartData,
	getToDoResponseSet,
	getUpcomingResponseSet,
	getUsefulLinks,
	getVersionInfo,
	getNurseToDoResponseSet,
	logActivity,
	login,
	logout,
	recordHelpAccessed,
	register,
	saveCost,
	saveResponse,
	setConsent,
	setConsentConfirmed,
	setHelpAccessed,
	//setInitialQuestionnaires,
	setPID,
	setResponse,
	setSettings,
	validateInitialRegistrationData,
	validateVerificationCode,
	validatePID,
};
